<template>
  <div class="container">

    <div class="top-wrap">
      <!-- 图片裁剪 -->
      <div class="img-canvas" id="clipArea"></div>
    </div>
		

    <!-- 文字输入层 -->
    <div class="word-input-wrap hide"
      :class="{'is-show':isShow}">
      <div class="bg" @click="inpResetBg"></div>
      <textarea autofocus id="textInp" ref="textArea"></textarea>

      <div class="text-confirm-wrap">
        <div class="text-confirm show-flex-c" @click="inpConfirm">确认</div>
      </div>
    </div>

    <!-- 文字输入之后 显示层 -->
    <div class="canv_top" id="wordShowParent">
      <div class="word-show word-show-h show-flex-c">
        <div class="word-cont infinite animated" :class="aniObj"></div>
        <div class="word-cont infinite animated" :class="aniObj"></div>
        <img v-if="tSelectIndex>=2" class="gif-img" :src="gifUrl | imgUrl" />
      </div>
    </div>

    <!-- 表情包选择 -->
    <div class="expression-wrap show-flex">
      
      <div class="exp-item" @click="expType(0)">
        <div :class="[tSelectIndex == 0 ? 'type-active' :'']" class="exp_inner show-flex-c"><img src="../../static/img/exp_type_1.png"></div>
        无
      </div>
      <div class="exp-item" @click="expType(1)">
        <div :class="[tSelectIndex == 1 ? 'type-active' :'']"  class="exp_inner show-flex-c"><img src="../../static/img/exp_type_2.png"></div>
        文字
      </div>
      <div v-for="(item,index) in expList" :key="index" class="exp-item" @click="expType(index + 2)">
        <div :class="[tSelectIndex == index+2 ? 'type-active' :'']" class="exp_inner show-flex-c"><img :src="item.imgUrl | imgUrl"></div>
        {{item.name}}
      </div>

    </div>

    <!-- 动效选择 -->
    <div class="exp-ani-wrap show-flex" v-if="showAniType">
      <img class="ani-label" src="../../static/img/dynamic_type.png" alt="">

      <div class="ani-box show-flex-c">
        <div class="ani-item" 
          v-for="(item,index) in wordList"
          :key="index"
          :class="[selectIndex==item.index?'ani-active':'']" 
          :data-index="item.index"
          @click="expAniType(item.index)">
          {{item.name}}
        </div>
      </div>
    </div>
    
    <div class="to-img" id="clipBtn"
      @click="finishEdit">
      <div>完成</div>
    </div>

    <div class="loading show-flex-c" v-if="loading">
      <img src="../../static/img/loading.gif" alt="">
      <span>正在生成表情</span>
    </div>

    <!-- 加载图片loading -->
    <div class="loading show-flex-c" v-if="loading_img">
      <img src="../../static/img/loading.gif" alt="">
      <span>正在加载图片</span>
    </div>
  </div>
</template>

<script>
// import CanvasToImg from "../components/CanvasToImg";

let img64Url =''; //base64 图片地址
let content = ''; //输入的文字
let _type = 0;    //0静态   1动态

export default {
  name: 'ExpressionMain',
  data () {
    return {
      expList:[], //表情类型
      wordList:[],//文字动效类型
      gifUrl:'',//gif 显示

      isFocus: false,//是否聚集
      isShow: false,//输入框显示
      wordCont: "",//文字内容

      selectIndex:0,//动效选择

      tSelectIndex:0,//表情包类型  选择

      aniObj:{},  //动效 效果

      loading: false,//生成表情
      loading_img:true,//加载图片      

      showAniType: false,//选择动效 显示
      // btnDisable:true,//完成 是否能点，  默认disable

      bqCode:'', //比趣code
      imgId:1,//比趣图片id
      img:'https://running.osports.cn/biqu/page/expression/static/img/bg.jpg',//比趣 图片地址
    }
  },
  created () {
    this.getExpList();
    this.getAniName();
  },
  mounted(){
    let qu = this.$route.query;
    console.log(qu)
    // alert(JSON.stringify(qu))

    try{
      this.imgId = qu.imgId || this.imgId;
      this.img = qu.img || this.img;
      this.bqCode = qu.bqCode || 'AAF5F08393B6C2BE';
    }finally{
      setTimeout(()=>{
        this.imgCanv();
      },300)
    }
  },
  methods:{
    //获取动效类型
    getAniName(){
      this.wordList=[{
        index:0,
        name:'无动效'
      },{
        index:10,
        name:'闪烁'
      },{
        index:1,
        name:'弹现'
      },{
        index:2,
        name:'摇晃'
      },{
        index:3,
        name:'皮筋'
      },{
        index:4,
        name:'蹦跳'
      },{
        index:5,
        name:'从天而降'
      },{
        index:6,
        name:'底部升起'
      },{
        index:7,
        name:'上下颠簸'
      },{
        index:8,
        name:'左右晃动'
      },{
        index:9,
        name:'放大缩小'
      },{
        index:11,
        name:'跷跷板'
      }]
    },
    //获取gif jpg 表情类型
    getExpList(){
      let arr = [];
      let obj1 = {
        name: "无",
        id: -1,
        url: "/static/img/exp_type_1.png"
      };
      let obj2 = {
        name: "文字",
        id: 0,
        url: "/static/img/exp_type_2.png"
      };
      // arr.push(obj1);
      // arr.push(obj2);
      this.expList = arr;
      this.$http.get('/page/expression/js/gifElmt.js?t='+new Date().getTime())
        .then( res => {
          let d = res.data;
          if(d.result){
            if(!d.list.length){
              return;
            }
            this.expList = [...arr,...d.list];
          }else{
            // alert(d.message)
          }
        })
        .catch( err => {

        })
    },
    //输入取消
    inpReset(){
      // this.isShow = false;
      $('.word-input-wrap').hide();      
      // if(!$('.word-show .word-cont').html().length){
      //   this.btnDisable = true;
      // }
    },
    inpResetBg(){
      $('.word-input-wrap').hide();
      // if(!$('.word-show .word-cont').html().length){
      //   this.btnDisable = true;
      // }
    },
    //重置
    reset(){
      this.isShow = false;
      
    },
    //输入 确认
    inpConfirm(){
      content = $('#textInp').val().replace(/[\r\n\s]/g,"");
      let html= $('#textInp').val().replace(/\n/g, '_@').replace(/\r/g, '_#');
      
      html = html.replace(/_#_@/g, '<br/>');//IE7-8
      html = html.replace(/_@/g, '<br/>');//IE9、FF、chrome
      html = html.replace(/\s/g, '&nbsp;');//空格处理
      html = html.replace(/\"/g, "");//去除双引号

      this.wordCont = html;
      $('.word-show .word-cont').eq(0).html(html);

      this.$nextTick(()=>{
        setTimeout(()=>{
          this.inpReset();
        },0)
        // this.wordInput = false;
      })
      

      if(html.length){
        this.showAniType = true;
        // this.btnDisable = false;
      }
    },

    //完成编辑
    finishEdit(){
      //无操作不允许下一步
      // if(this.btnDisable){
      //   return;
      // }

      let divCss = $('#wordShowParent').html();
      _type = this.selectIndex>=1 ? 1 : 0;   //0静态   1动态
      let duration = _type==1 ? 1 : .1;   //0静态   1动态
      let imgId = this.imgId;

      this.loading = true;

      let url = this.tSelectIndex>1
        ? '/make/gif/element/'+imgId
        : '/make/gif/picTxt/'+imgId;

      let eleId = 0;
      if(this.tSelectIndex>=2){
        eleId = this.expList[this.tSelectIndex - 2].id || 0;
      }
      
      setTimeout(()=>{

        let _data = {};
        if(this.tSelectIndex>1){
          _data = {
            picSrc : img64Url,
            eleId: eleId,
            bqCode: this.bqCode
          }
        }else{
          _data = {
            picSrc : img64Url,
            bqCode: this.bqCode,            
            divCss,
            content,
            type: _type,
            duration,
          }
        }
          
        let data = this.$qs.stringify(_data);

        console.log(data)
        // return;
        this.$http.post(url,data)
          .then( res => {
            let d = res.data;
            if(d.result){
              

              let {gifUrl,id} = d;
              this.$router.push({
                path:'ExpressionView',
                query:{
                  gifUrl,
                  id
                }
              })

            }else{
              // alert(d.message)
            }
            this.loading = false;
          })
          .catch( err => {
            this.loading = false;
          })
      },0)

    },
    //选择表情类型
    expType(type) {
      if(type == 0){
        $('.word-show .word-cont').html('');
        this.showAniType = false;       
        // this.btnDisable = true;         
      }
      else if(type == 1){//文字
        // this.wordInput = true;
        this.isShow = true;
        $('.word-input-wrap').show();
        $('#textInp').focus();
        
        this.$nextTick(()=>{
          $('#textInp').focus();
          // alert(1);
        });
        // $('#textInp').focus();
        // setTimeout(()=>{
        //   $('#textInp').focus();
        //   // alert(1);
        // },10)
        this.$nextTick(function(){
          // $('#textInp').focus();
          // alert(1);
        });
        // this.showAniType = true; //显示选择动效       
      }else if(type >= 2){//mvp
        this.gifUrl = this.expList[type-2].eleUrl;
        this.aniObj = {};
        this.showAniType = false;  
        $('.word-show .word-cont').html('');      
        // this.btnDisable = false;                        
      }
      this.tSelectIndex = type;

      if(type != 1){
      }
    },
    //选择动效类型
    expAniType(type){
      this.selectIndex = type;
      if(type == 0){
        this.aniObj={}
      }else if(type == 1){//闪放
        this.aniObj = {
          'scaleOpacity1':true
        };
      }else if(type == 2){//闪放2
        this.aniObj = {
          'scaleOpacity2':true
        };
      }else if(type == 3){//闪放3
        this.aniObj = {
          'scaleOpacity3':true
        };
      }else if(type == 4){//闪放4
        this.aniObj = {
          'scaleOpacity4':true
        };
      }else if(type == 5){//从天而降
        this.aniObj = {
          'fadeInDownBig':true
        };
      }else if(type == 6){//底部升起
        this.aniObj = {
          'fadeInUpBig':true
        };
      }else if(type == 7){//上下颠簸
        this.aniObj = {
          'upToDown':true
        };
      }else if(type == 8){//左右晃动
        this.aniObj = {
          'shake':true
        };
      }else if(type == 9){//放大缩小
        this.aniObj = {
          'pulse':true
        };
      }else if(type == 10){//突然闪现
        this.aniObj = {
          'flash':true
        };
      }else if(type == 11){//跷跷板
        this.aniObj = {
          'swing':true
        };
      }

      //改变
      if(type >= 1 && type<=4){
        let html = ``;
        for (let i of content) {
          html+=`<div class='animated infinite'>${i}</div>`;
        }
        $('.word-cont').eq(1).html(html);
        $('.word-cont').eq(0).hide();
        $('.word-cont').eq(1).show();
      }else{
        $('.word-cont').eq(1).hide();
        $('.word-cont').eq(0).show();
      }
    },

    //初始化截图
    imgCanv(){
      let imgUrl = this.img;
      let w = $('#clipArea').width();
      let h = $('#clipArea').height();
      
      let self = this;

      var src= imgUrl;
      var pc = new PhotoClip('#clipArea', {
        size:[w,w],
        // outputSize: 200,
        outputQuality: 0.8,
        img: src,
        view: "#view",
        ok: "#clipBtn",
        maxZoom:4,
        loadStart: function () {
          // $(".loading_middle").show();
          self.loading_img = true;
          // alert(self.loading_img)
        },
        loadComplete: function () {
          // $(".loading_middle").hide();
          self.loading_img = false;   
          // alert(self.loading_img)
        },
        done: function (dataURL1) {
          img64Url = dataURL1;
        },
        fail: function(msg) {
          alert(msg);
        }
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.container{
  font-size: .28rem;
  /* overflow: hidden; */
  color: #808080;
}
.top-wrap{
  /* padding: .28rem .65rem; */
  padding: .46875rem 1.015625rem;
  background: #fafafa;
  border-bottom: .015625rem solid #e1e1e1;
}
.expression-wrap{
  overflow-x: scroll;
  font-size: .375rem;
  flex-wrap: nowrap;
  -webkit-flex-wrap: nowrap;
  padding: .2rem .2rem .28rem .2rem;
  color: #999;
}

.exp-item{
  padding-right: .2rem;
  flex: none;
  -webkit-flex: none;
}
.exp_inner{
  width: 2.65625rem;
  height: 2.65625rem;
  border: .015625rem solid #e6e6e6;
  margin-bottom: .015625rem;
}
.exp_inner>img{
  /* width: 1.875rem; */
  width: 100%;
}


.word-input-wrap{
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
}
.word-input-wrap> .bg{
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: -1;
}

.word-input-wrap>textarea{
  width: 100%;
  height: 9rem;
  background: transparent;
  font-size: 1rem;
  color: #fff;
  padding: .46875rem .9375rem;
  border: 0;

}
.text-confirm-wrap{
  position: fixed;
  width: 10rem;
  bottom: 0;
  left: 50%;
  margin-left: -5rem;
  background: #fff;
  height: 1rem;
  overflow: hidden;
}
.text-confirm{
  float: right;
  color: #fff;
  font-size: .34375rem;
  /* display: block; */
  background: #23d0a5;
  width: 1.40625rem;
  height: .6875rem;
  /* line-height: .6875rem; */
  text-align: center;
  margin-top: .1875rem;
  margin-right: .375rem;
  border-radius: .140625rem;
}

.canv_top{
  pointer-events: none;
}


.img-canvas {
  width: 7.96875rem;
  height: 7.96875rem;
  overflow: hidden;
}
.exp-ani-out{
  height: 1.5625rem;
}
.to-img{
  color: #fff;
  font-size: .34375rem;
  display: table;
  background: #23d0a5;
  width: 1.875rem;
  height: .78125rem;
  /* line-height: 0;
  padding: .21875rem 0; */
  text-align: center;
  margin: .46875rem auto 0;
  border-radius: .140625rem;
  overflow: hidden;
  /* position: fixed;
  left: 50%;
  bottom: 0;
  margin-left: -0.9375rem; */
}
.to-img>div{
  display: table-cell;
  vertical-align: middle;
}
.exp-ani-wrap{
  overflow: hidden;
  padding-left: .3125rem;
}
.ani-label{
  width: 1.34375rem;
  height: 1.5625rem;
  flex: none;
  -webkit-flex: none;
  margin-right: .375rem;
}
.ani-box{
  overflow-x: scroll;
  overflow-y: hidden;
  flex-wrap: nowrap;
  -webkit-flex-wrap: nowrap;
  flex: 1;
  -webkit-flex: 1;
  justify-content: flex-start;
  -webkit-justify-content: flex-start;
}
.ani-item{
  border: .015625rem solid #e0e0e0;
  border-radius: .140625rem;
  overflow: hidden;
  width: 1.875rem;
  height: .96875rem;
  line-height: .96875rem;
  text-align: center;
  flex: none;
  -webkit-flex: none;
  margin-right: .46875rem;
  font-size: .3125rem;
}

.ani-active{
  border: .015625rem solid #f9cd6a;
  background: url('../../static/img/effect_active.png') right bottom no-repeat;
  background-size: .484375rem .5rem;
}

.type-active{
  border: .046875rem solid #f8d04a;
}

#clipArea >>> .photo-clip-mask{
  display: none;
}


.word-show>>> .gif-img{
  width: 100%;
}

.s-gif-img{
  width: 1.875rem;
}

.word-show{
  position: absolute;
  color:#fff;
  align-items: flex-end;
  -webkit-align-items: flex-end;
  align-content: flex-end;
  -webkit-align-content: flex-end;
  width: 100%;
  height: 100%;
  left: 0;
  right: 0;
  top: 0;
  height: 8.9rem;
  font-size: 1rem;
  text-align: center;
  padding: .46875rem 1.015625rem;
}
.word-show>>>.word-cont{
  display:inline-block;
  margin-bottom: .6rem;
}
.word-show>>>.word-cont>div{
  display:inline-block;
}

.loading{
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  overflow: hidden;
  flex-direction: column;
  -webkit-flex-direction: column;
}
.loading>img{
  width: 1.5625rem;
  margin-bottom: .46875rem;
}
.loading > span{
  color: #fafafa;
  font-size: .40625rem;
}

.btn-disable{
  background: #ccc;
}
.hide{
  display: none;
}
.is-show{
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/ExpressionMain.vue